const defaultValues = {
  event: "virtualEvent",
  tipoZona: "Vida",
  zona: "FondoVidaGarantizadoSimulador",
  partner: "Pacífico",
  partnerType: "Pacífico",
};

export const gtmOnclick = ({ subZona, seccion, tipoEvento, tipoElemento, valor }) => {
  if (!subZona || !seccion || !tipoEvento || !tipoElemento || !valor) {
    console.warn("gtmOnclick: falta información esencial para trackear evento.");
    return;
  }

  if (typeof window.dataLayer === 'undefined') {
    console.warn("gtmOnclick: 'dataLayer' no está definido en el contexto global.");
    return;
  }

  window.dataLayer.push({
    ...defaultValues,
    subZona,
    seccion,
    tipoEvento,
    tipoElemento,
    valor,
  });
};
